/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MaximizeIcon = ({ width = 24, height = 24, hidden = false, title = 'Maximize' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M14.077 20.707a1 1 0 0 0-1.414 0l-6.484 6.484L3.2 24.206A.688.688 0 0 0 2.705 24a.7.7 0 0 0-.7.7v8.84a.5.5 0 0 0 .454.46H11.3a.7.7 0 0 0 .7-.7.685.685 0 0 0-.207-.49l-2.984-2.989 6.484-6.484a1 1 0 0 0 0-1.414ZM33.541 2H24.7a.7.7 0 0 0-.7.705.685.685 0 0 0 .207.49l2.984 2.984-6.484 6.484a1 1 0 0 0 0 1.414l1.216 1.216a1 1 0 0 0 1.414 0l6.484-6.484 2.984 2.985A.688.688 0 0 0 33.3 12a.7.7 0 0 0 .7-.7V2.459A.5.5 0 0 0 33.541 2Z"
    />
  </svg>`;
};
